import React from "react";
import styles from "./SocietyAdminStripeSubsriptionStatus.module.css"
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useDataFetch from "../../../hooks/useDataFetch";
import {Link} from "@mui/material";

interface StripeSubscription {
    status: string;
    trialEnd: string;
}

interface StripeCustomerPortal {
    url: string;
}

const SocietyAdminStripeSubscriptionStatus = () => {
    const {data: stripeSubscription} = useDataFetch<StripeSubscription>('/stripe/retrieve-subscription', true, true, false);
    const {data: stripeCustomerPortal} = useDataFetch<StripeCustomerPortal>('/stripe/retrieve-customer-portal-link', true, true, false);

    return (
        <Box sx={{
            width: "100%",
            backgroundColor: 'secondary.main',
            alignContent: 'center'
        }}>

            <Box
                sx={{
                    backgroundColor: "secondary.main",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <div className={styles.content}>
                    <div className={styles.realContent}>
                        <Typography
                            variant={"secondVariant"}
                            sx={{
                                fontSize: {xs: 25, sm: 30}
                            }}
                        >
                            Votre abonnement
                        </Typography>

                        {stripeSubscription && (
                            <>
                                <Typography
                                    variant={"secondVariant"}
                                >
                                    Statut: {stripeSubscription.status}
                                </Typography>
                                {stripeSubscription.status === "trialing" && (
                                    <>
                                        <Typography
                                            variant={"secondVariant"}
                                        >
                                            Fin de la période d'essai: {stripeSubscription.trialEnd}
                                        </Typography>

                                        <Typography
                                            variant={"secondVariant"}
                                        >
                                            Changer d'abonnement avant la fin de la période d'essai mettra fin à la période d'essai gratuite.
                                        </Typography>
                                    </>
                                )}

                                {stripeCustomerPortal && (
                                    <Link
                                        mt={4}
                                        variant={"firstVariant"}
                                        href={stripeCustomerPortal?.url}
                                    >
                                        Gérer l'abonnement
                                    </Link>
                                )}


                            </>
                        )}

                    </div>
                </div>
            </Box>
        </Box>
    );
}

export default SocietyAdminStripeSubscriptionStatus
